import { concat, fn, hash } from '@ember/helper';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import { service } from '@ember/service';

import { t } from 'ember-intl';

import Component from 'umg-ember-backend/components/record-explorer';
import Table from 'umg-ember-backend/components/record-explorer/table';
import Toolbar from 'umg-ember-backend/components/record-explorer/toolbar';
import Pagination from 'umg-ember-backend/components/ui/pagination';
import Window from 'umg-ember-backend/components/ui/window';

export default class ListComponetsFrontendUserComponent extends Component {
  // Services
  @service fetch;
  @service flashMessages;
  @service intl;
  @service recordLocks;

  // Defaults
  availableFilters = [
    ...this.defaultFilters,
    {
      key: 'status',
      options: [0, 1, 2, 3, 4, 5, 6],
      type: 'selectValueLabel',
    },
    {
      key: 'siteId',
      options: [19, 1762, 1925],
      type: 'selectValueLabel',
    },
  ];

  defaultColumns = [
    'id',
    'firstName',
    'lastName',
    'company',
    'email',
    'siteId',
    'cmsCreated',
    'lastLogin',
    'unlockedAt',
    'status',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'lastName',
      sortable: true,
      isMainColumn: true,
    },
    {
      isLinkToDetail: true,
      property: 'firstName',
      sortable: true,
    },
    {
      property: 'company',
      sortable: true,
    },
    {
      property: 'email',
      sortable: true,
    },
    {
      property: 'siteId',
      sortable: true,
    },
    {
      property: 'status',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'unlockedAt',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'lastLogin',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];

  // Actions
  lockOrUnlockUser = async (selectedUser) => {
    try {
      const action = selectedUser.status === 2 ? 'lock' : 'unlock';
      let response = await this.fetch.post(`/frontendUsers/${action}`, {
        data: {
          userId: selectedUser.get('id'),
        },
      });

      selectedUser.set('status', response.frontendUser.status);
      selectedUser.set('unlockedAt', response.frontendUser.unlockedAt);
      this.recordLocks.unlock(selectedUser);

      this.flashMessages.success(`flash.user_${action}.success`);
    } catch (error) {
      this.flashMessages.serverError(error);
    }
  };

  // Template
  // We need to overwrite the default template to lock or unlock user
  <template>
    <Window
      @isBottombarVisible={{if this.recordsData.length true false}}
      @isLoading={{this.loadRecords.isRunning}}
      @isSeamless={{true}}
      @onBodyScroll={{this.setScrollPosition}}
      @scrollPosition={{this.scrollPosition}}
      {{didInsert this.setOrLoadRecords}}
    >
      <:title>
        {{t (concat 'models.plurals.' this.recordType)}}
      </:title>

      <:toolbar>
        <Toolbar
          @activeColumns={{this.activeColumns}}
          @activeFilters={{this.activeFilters}}
          @availableFilters={{this.availableFilters}}
          @columns={{this.tableColumns}}
          @recordType={{this.recordType}}
          @onAddRecord={{this.addRecord}}
          @onAssignRelation={{@onAssignRelation}}
          @onSearch={{this.search}}
          @onSetFilter={{this.setFilter}}
          @parentRecordType={{@parentRecordType}}
          @searchString={{this.searchString}}
          @selectedRecords={{this.selectedRecords}}
        />
      </:toolbar>

      <:body>
        <Table
          @activeSort={{this.activeSort}}
          @columns={{this.visibleColumns}}
          @records={{this.recordsData}}
          @recordType={{this.recordType}}
          @recordActions={{hash
            edit=this.loadRecord
            duplicate=this.duplicateRecord
            delete=this.deleteRecord
            lockOrUnlockUser=this.lockOrUnlockUser
          }}
          @selectedRecords={{this.selectedRecords}}
          @onAssignRelation={{@onAssignRelation}}
          @onUpdateSort={{fn this.setFilter 'sort'}}
          @onSelectRecord={{this.selectRecord}}
        />
      </:body>

      <:bottombar>
        <Pagination
          @pagination={{this.records.meta}}
          @setPage={{this.setPage}}
          @setPageLimit={{fn this.setFilter 'pageSize'}}
        />
      </:bottombar>
    </Window>
  </template>
}
